import { typography } from '../theme/tokens';
import styled from '@emotion/styled';

// Title Components
export const TitleLarge = styled.h1`
  ${typography.titles.large}
`;

export const TitleMedium = styled.h2`
  ${typography.titles.medium}
`;

export const TitleSmall = styled.h3`
  ${typography.titles.small}
`;

// Subtitle Components
export const SubtitleLarge = styled.h4`
  ${typography.subtitle.large}
`;

export const SubtitleMedium = styled.h5`
  ${typography.subtitle.medium}
`;

export const SubtitleSmall = styled.h6`
  ${typography.subtitle.small}
`;

// Paragraph Components
export const ParagraphLarge = styled.p`
  ${typography.paragraph.large}
`;

export const ParagraphMedium = styled.p`
  ${typography.paragraph.medium}
`;

export const ParagraphSmall = styled.p`
  ${typography.paragraph.small}
`;

// Label Components
export const LabelLarge = styled.label`
  ${typography.label.large}
`;

export const LabelMedium = styled.label`
  ${typography.label.medium}
`;

export const LabelSmall = styled.label`
  ${typography.label.small}
`;

// UI Components
export const ButtonText = styled.span`
  ${typography.ui.button}
`; 